import Repository from "../Repository";

const resource = "/targetings";
export default {
    get() {
        return Repository.get(`${resource}`);
    },
    getTargeting(id) {
        return Repository.get(`${resource}/${id}`);
    },
    create(json) {
        return Repository.post(`${resource}`, json);
    },
    update(id, json) {
        return Repository.put(`${resource}/${id}`, json);
    },
    delete(id) {
        return Repository.delete(`${resource}/${id}`);
    }
}